<template>
  <div class="h-full p-20px">
    <div style="margin-bottom: 6px">
      <Button color="primary" @click="exportAssetsOutDetails()">导出</Button>
      <Button color="primary" @click="printDetails()">打印</Button>
    </div>
    <vxe-table border height="90%" ref="xTable" :loading="loading" show-overflow stripe :data="dataList">
      <vxe-column title="日期" field="checkDate" width="100"/>
      <vxe-column title="凭证号" field="voucherTitle" width="100"/>
      <vxe-column title="摘要" field="digest" width="200"/>
      <vxe-colgroup align="center" title="原值">
        <vxe-column title="借方" align="right" width="100" field="originalDebit" formatter="toMoney"/>
        <vxe-column title="贷方" align="right" width="100" field="originalCredit" formatter="toMoney"/>
        <vxe-column title="余额" align="right" width="100" field="originalBalance" formatter="toMoney"/>
      </vxe-colgroup>
      <vxe-colgroup align="center" title="累计折旧">
        <vxe-column title="借方" align="right" width="100" field="depreciationDebit" formatter="toMoney"/>
        <vxe-column title="贷方" align="right" width="100" field="depreciationCredit" formatter="toMoney"/>
        <vxe-column title="余额" align="right" width="100" field="depreciationBalance" formatter="toMoney"/>
      </vxe-colgroup>
      <vxe-colgroup align="center" title="减值准备">
        <vxe-column title="借方" align="right" width="100" field="impairmentDebit" formatter="toMoney"/>
        <vxe-column title="贷方" align="right" width="100" field="impairmentCredit" formatter="toMoney"/>
        <vxe-column title="余额" align="right" width="100" field="impairmentBalance" formatter="toMoney"/>
      </vxe-colgroup>
      <vxe-column title="净值" align="right" width="100" field="netValue" formatter="toMoney"/>
      <vxe-column title="使用状况" field="useState" width="100"/>
      <!-- <vxe-column title="使用部门" field="deptName" width="100"/> -->
      <vxe-column title="使用部门" field="deptName" width="100">
        <template #default="{ row }">
          {{ getDeptName(row.deptId) }}
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Assets from "@/api/Assets";

export default {
  name: "AssetsDetails",
  props: {
    assets: Object,
    deptList: Array
  },
  data() {
    return {
      filterVal: null,
      loading: false,
      dataList: []
    }
  },
  methods: {
    printDetails(){
      console.log(this.assets)
      const topHtml = `
        <div style="text-align:left;font-size: 16px;"><h3>${this.assets.code}-${this.assets.name}资产信息</h3></div>
      ` 
      let $table = this.$refs.xTable;
      if ($table) {
        $table.print({
          // sheetName: '打印出货单据',
          // // 打印样式设置
          // style: printStyle,
          // // 打印指定列
          // columns: [
          //   { type: 'seq' },
          //   { field: 'name' },
          //   { field: 'role' },
          //   { field: 'address' }
          // ],
          // 打印之前拼接自定义模板
          beforePrintMethod: ({ content }) => {
            // 打印之前，返回自定义的 html 内容
            return topHtml + content
          }
        })
      }
    },
    exportAssetsOutDetails(){
      let $table = this.$refs.xTable;
      if ($table) {
        $table.exportData({ 
          type: 'csv',
          filename: `${this.assets.code}-${this.assets.name}资产信息`,
      })
      }
    },
    getDeptName(deptId) {
      if(deptId){
        let name = this.deptList.find(item => item.key === deptId).title;
        return name ? name : '';
      }
      return '';
    },
    loadList() {
      this.loading = true
      Assets.detail(this.assets.id).then(({data}) => {
        this.dataList = data || [];
      }).finally(() => this.loading = false)
    }
  },
  created() {
    this.loadList();
  }
}
</script>
